<div class="coupons-list-root">
  <app-filter-area 
    content 
    [chipContents]="chipContents" 
    [isGrayBlue]="true" 
    (selectedFilter)="getFilter($event)"
    [isCarousel]="false">
  </app-filter-area>
  <div class="title">
    {{labels.coupons}}
  </div>
  <div class="coupon-vip" *ngIf="couponsVip">
    <div class="label">
      {{ labels.vipCoupon }}
    </div>
    <div *ngFor="let couponVip of couponsVip">
      <app-coupon-card-slim-vip [coupon]="couponVip"></app-coupon-card-slim-vip>
    </div>
  </div>
  <div
    *ngIf="couponsList.length && !loading "
    class="coupons-list"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullCoupons()">
    <div class="label">
      <div>
        {{ labels.rewardCoupons }}
      </div>
      <div class="divider"></div>
    </div>
    <ng-container *ngFor="let coupon of couponsList">
      <app-coupon-card-slim [coupon]="coupon"></app-coupon-card-slim>
    </ng-container>
    <mat-spinner diameter="15" [ngClass]="{hidden: !pulling}">
    </mat-spinner>
  </div>
  <div
    *ngIf="!couponsList.length && !loading"
    class="no-coupons-list">
    <app-circle>
      list_alt
    </app-circle>
    <app-label class="big text" isBig>
      {{labels.notFound}}
    </app-label>
    <app-label class="small text" isGray>
      {{labels.notFoundDescription}}
    </app-label>
  </div>
</div>
